<template>
  <div>
    <BCard no-body class="mb-0">
      <!-- Filtros -->
      <div class="m-2">
        <BRow>
          <BCol cols="12" md="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
            <label>{{ $t('Show') }}</label>
            <vSelect v-model="perPage" :options="perPageOptions" :clearable="false" class="per-page-selector d-inline-block mx-50" />
            <label>{{$t('entries')}}</label>
          </BCol>
          <BCol cols="12" md="6">
            <div class="d-flex align-items-center justify-content-between">
              <!-- <BFormInput v-model="searchQuery" class="d-inline-block mr-1" :placeholder="$t('Search') + '...'"  /> -->
              <TextInputValidated :vsModel.sync="searchQuery" :vsCols="false" vsPlaceholder="Buscar ..." class="d-inline-block mr-1" />
              <BButton variant="primary" :to="{ name: 'sections-add' }" v-if="ability.can('create', 'section')">
                <span class="text-nowrap">{{$t('Add Section')}}</span>
              </BButton>
            </div>
          </BCol>
        </BRow>
      </div>
      <!-- Tabla -->
      <BTable ref="sectionTable" class="position-relative" :items="fetchSections" :fields="tableColumns" :sort-by.sync="sortBy" :empty-text="$t('No match records found')" :sort-desc.sync="isSortDirDesc" primary-key="id" responsive show-empty>

      <template #cell(name)="data">
        <BLink :to="{ name: 'sections-view', params : { id: data.item.id } }"> {{ data.item.name }} </BLink>
      </template>
      
      <template #cell(actions)="data">
          <BDropdown variant="link" no-caret :right="$store.state.appConfig.isRTL">

            <template #button-content>
              <FeatherIcon icon="MoreVerticalIcon" size="16" class="align-middle text-body" />
            </template>
            <BDropdownItem :to="{ name: 'sections-view', params: { id: data.item.id } }" v-if="ability.can('read', 'section')">
              <FeatherIcon icon="FileTextIcon" />
              <span class="align-middle ml-50">{{$t('Details')}}</span>
            </BDropdownItem>

            <BDropdownItem :to="{ name: 'sections-edit', params: { id: data.item.id } }" v-if="ability.can('write', 'section')">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">{{$t('Edit')}}</span>
            </BDropdownItem>

            <BDropdownItem @click="deletePopup(data.item.id, 'sections/deleteSection')" v-if="ability.can('delete', 'section')">
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">{{$t('Delete')}}</span>
            </BDropdownItem>
          </BDropdown>
        </template>
      </BTable>
      <!-- Paginación -->
      <div class="mx-2 mb-2">
        <BRow>
          <BCol cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
            <span class="text-muted">{{$t('Showing')}} {{dataMeta.from}} {{$t('to')}} {{dataMeta.to}} {{$t('of')}} {{dataMeta.of}} {{$t('entries')}}</span>
          </BCol>
          <BCol cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
            <BPagination v-model="currentPage" :total-rows="totalSections" :per-page="perPage" first-number last-number class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
              <template #prev-text> <feather-icon icon="ChevronLeftIcon" size="18" /> </template>
              <template #next-text> <feather-icon icon="ChevronRightIcon" size="18"/> </template>
            </BPagination>
          </BCol>
        </BRow>
      </div>

    </BCard>
  </div>
</template>

<script>
import { BCard, BTable, BRow, BCol, BPagination, BDropdown, BDropdownItem, BButton, BFormInput, BLink } from "bootstrap-vue";
import { onUnmounted } from "@vue/composition-api";
import sectionListQuery from './sectionListQuery'
import sectionsModule from "../sectionsModule";
import ability from '@/libs/acl/ability';
import popups from "@/hooks/popups";
import vSelect from 'vue-select';
import store from "@/store";
import TextInputValidated from '@/components/forms/TextInputValidated.vue'

export default {
  components: { BCard, BTable, BRow, BCol, BPagination, BDropdown, BDropdownItem, BButton, vSelect, BFormInput, BLink, TextInputValidated },
  setup() {
        const SECTION_MODULE = 'sections'
        const { deletePopup } = popups()
        const { fetchSections, tableColumns, perPage, currentPage, totalSections, dataMeta, perPageOptions, searchQuery, sortBy, isSortDirDesc, sectionTable, refetchData } = sectionListQuery()

        if (!store.hasModule(SECTION_MODULE)) {
            store.registerModule(SECTION_MODULE, sectionsModule)
        }

        onUnmounted(() => {
            if (store.hasModule(SECTION_MODULE)) {
                store.unregisterModule(SECTION_MODULE)
            }
        })

      return {
        fetchSections,
        tableColumns,
        perPage,
        currentPage,
        totalSections,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        sectionTable,
        refetchData,
        ability,
        deletePopup
      }
    }
}
</script>

<style lang="scss">
  @import '~@core/scss/vue/libs/vue-select.scss';
</style>